






import Component from "vue-class-component";
import Vue from 'vue';

@Component({})

export default class SocialsSharing extends Vue {
    private pageUrl = window.location.href;
    private text = 'Join Festa!!!';
    private get telegramLink(): string
    {
        return `https://t.me/share/url?url=${this.pageUrl}&text=${this.text}`;
    }
}
